import React from 'react';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import '../../styles/insightCards.css';

export default function LobsterProcessing(_props: RegistryComponentProps): React.ReactElement {
  return (
    <div className="insight-card">
      <div className="insight-title-row">
        <h3 className="insight-title">Processing (Statewide)</h3>
      </div>
      <div className="insight-columns">
        <div className="insight-column" style={{ marginRight: 0 }}>
          <div className="assessment-metric-item">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span className="column-header" style={{ textAlign: 'left', marginBottom: 0 }}>
                Employment
              </span>
              <span className="insight-value" style={{ textAlign: 'right' }}>
                2,271
              </span>
            </div>
          </div>
          <div className="assessment-metric-item" style={{ marginTop: '12px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span className="column-header" style={{ textAlign: 'left', marginBottom: 0 }}>
                Value Added
              </span>
              <span className="insight-value" style={{ textAlign: 'right' }}>
                $156,000,000
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
